import { Injector } from "@angular/core";

export const providerUpgradeFactory =
  (serviceName: string) =>
  <T>($injector: Injector): T => {
    return $injector.get(serviceName);
  };
